let globalContext: Record<string, any> = {
    client_type: 'web',
};

export const setContext = (context: Record<string, any>) => {
    globalContext = {...globalContext, ...context};
};

export const getContext = () => ({
    ...globalContext,
    timestamp: Date.now(),
});
